import {ACTIVITY_VIEW_ALL, PERMISSION_PARTICIPANT_VIEW_ALL_ID, PERMISSION_SUPER_ADMIN_NAME} from '@evencel/api';
import {IPermission} from '../entity/permission';
import {IJwtValidatedUser} from '../req';

export function isSuperAdmin(user?: IJwtValidatedUser) {
    const s = user?.policies.map(p => p.name).includes(PERMISSION_SUPER_ADMIN_NAME);
    return s;
}

export function isActivityViewAll(user: IJwtValidatedUser) {
    return user?.policies.map(p => p._id?.toString()).includes(ACTIVITY_VIEW_ALL._id);
}

export function isParticipantViewAll(user: IJwtValidatedUser) {
    return user?.policies.map(p => p._id?.toString()).includes(PERMISSION_PARTICIPANT_VIEW_ALL_ID);
}

export function isSuperAdminWithPermissions(policies?: IPermission[]) {
    return policies?.map(p => p.name).includes(PERMISSION_SUPER_ADMIN_NAME);
}
